import RadioItem, { RadioItemProps } from './RadioItem';

export type { RadioItemProps };
export default RadioItem;
